import type { EmojiIconProps } from './EmojiIcon';
import type { EmojiPickerProps } from './EmojiPicker';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "AcceleratorEmojiPicker" */ './lazyIndex'),
    { name: 'AcceleratorEmojiPicker' }
);

// Delay loaded components
export const EmojiPicker: LazyComponent<EmojiPickerProps, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.EmojiPicker
);
export const EmojiIcon: LazyComponent<EmojiIconProps, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.EmojiIcon
);
export type { EmojiPickerProps } from './EmojiPicker';
export type { EmojiIconProps } from './EmojiIcon';
